/**
 *  Dutch language file
 */
import nl from 'vuetify/lib/locale/nl'

export default {
  ...nl,

  // Algemeen
  lang: {
    'English': 'Engels',
    'Dutch': 'Nederlands',
    'German': 'Duits',
    'Français': 'Frans',
    'english': 'Engels',
    'dutch': 'Nederlands',
    'german': 'Duits',
    'french': 'Frans'
  },

  userInfo: {
    noVendor: 'Geen vendor geselecteerd.'
  },

  noDataText: '',

  general: {
    name: 'Naam',
    user: 'Consumentennaam',
    createdAt: 'Gemaakt op',
    createdBy: 'Gemaakt door',
    lastSeen: 'Laatst gezien',
    actions: 'Acties',
    imei: 'Imei',
    frameNumber: 'Framenummer',
    odo: 'Odo',
    tags: 'Labels',
    active: 'Doelgroep',
    maintenance_plan: 'Onderhoudsplan',
    subscription: 'Abonnement',
    business: 'Relatie',
    title: 'Titel',
    iccid: 'ICCID',
    description: 'Omschrijving',
    firmware: 'Firmware',
    crc: 'CRC',
    entity: 'Voertuig',
    type: 'Type',
    color: 'Kleur',
    brand: 'Merk',
    model: 'Model',
    engine_brand: 'Motor merk',
    engine_model: 'Motor model',
    first_name: 'Voornaam',
    last_name: 'Achternaam',
    address: 'Adres',
    postcode: 'Postcode',
    city: 'Stad',
    phone: 'Telefoon',
    email: 'Email',
    additionalInfo: 'Aanvullende informatie',
    search: 'Zoeken',
    total: 'Totaal',
    sub_vendor: {
      name: 'Leverancier'
    },
    role: {
      name: 'Rol'
    },
    types: {
      eBike: 'e-bike',
      unregistered: 'NIET GEREGISTREERD',
      eCargoBike: 'bakfiets',
      speedPedelec: 'speed pedelec',
      eMoped: 'e-scooter',
      moped: 'scooter',
      automobile: 'automobiel',
      other: 'anders'
    },
    last_seen_at: 'Laatst gezien',
    save: 'Opslaan',
    cancel: 'Annuleren',
    close: 'Sluit',
    searched: 'Geen overeenkomende resultaten gevonden',
    months: {
      january: 'januari',
      february: 'februari',
      march: 'maart',
      april: 'april',
      may: 'mei',
      june: 'juni',
      july: 'juli',
      august: 'augustus',
      september: 'september',
      october: 'october',
      november: 'november',
      december: 'december'
    },
    serverError: 'Server fout'
  },

  dataFooter: {
    itemsPerPageText: 'Rijen per pagina:',
    itemsPerPageAll: 'Alles',
    nextPage: 'Volgende pagina',
    prevPage: 'Vorige pagina',
    firstPage: 'Eerste pagina',
    lastPage: 'Laatste pagina',
    pageText: '{0}-{1} van {2}'
  },

  messages: {
    created: 'aangemaakt',
    Created: 'Aangemaakt',
    deleted: 'verwijderd',
    Deleted: 'Verwijderd',
    updated: 'bijgewerkt',
    Updated: 'Bijgewerkt',

    confirmTitle: 'Weet je het zeker?',
    confirmText: 'Je staat op het punt om {0} te verwijderen. Weet je zeker dat je door wil gaan?',
    confirmTextHardDelete: 'Je staat op het punt om {0} PERMANENT TE VERWIJDEREN! Weet je zeker dat je door wil gaan?',
    confirmTextRestore: '{0} herstellen?',
    cancelButtonText: 'Annuleren',
    confirmButtonText: 'Ja, {0}',

    confirmDelete: 'verwijder',

    confirmResolveText: 'Je staat op het punt om {0} te markeren als gevonden. Weet je zeker dat je door wil gaan?',
    confirmResolve: 'markeer als opgelost.',
    confirmCloseText: 'Je staat op het punt om {0} te markeren als vermist. Weet je zeker dat je door wil gaan?',
    confirmClose: 'markeer als vermist',

    errorTitle: 'Oeps!',
    errorMessage: 'Er ging iets mis. {0}. Neem contact op met Tracefy voor ondersteuning.',
    successTitle: 'Jeej!',
    successMessage: '{0} is succesvol {1}!'

  },

  Navigation: {
    home: 'Home',
    map: 'Kaart',
    information: 'Informatie',
    installDevices: 'Trackers Installeren',
    analytics: 'Analyse',
    tags: 'Labels',
    reports: 'Rapportages',
    businesses: 'Relatie Beheer',
    entities: 'Voertuigen',
    users: 'Gebruikers',
    devices: 'Trackers',
    tokenManagement: 'Sleutels',
    subscriptions: 'Abonnementen',
    subscriptionManagement: 'Abonnementen Beheer',
    maintenancePlans: 'Onderhoudsplannen',
    notifications: 'App Notificaties',
    missing: 'Vermiste Fietsen',
    shop: 'Winkel',
    maintenanceBanner: 'Gepland onderhoud van',
    endYearNotice: 'Wilt u profiteren van de eindejaarsaanbieding?',
    clickHere: 'Klik hier!',
    until: 'tot'
  },

  Dashboard: {
    user: 'Welkom {0}',
    map: 'Kaart',
    installDevices: 'Trackers Installeren',
    information: 'Informatie',
    analytics: 'Analyse',
    tags: 'Labels',
    reports: 'Rapportages',
    businesses: 'Relatie Beheer',
    entities: 'Voertuigen',
    users: 'Gebruikers',
    devices: 'Trackers',
    tokenManagement: 'API Sleutels',
    subscriptions: 'Abonnementen',
    subscriptionManagement: 'Abonnementen Beheer',
    maintenancePlans: 'Onderhoudsplannen',
    notifications: 'App Notificaties',
    missing: 'Vermiste Fietsen',
    shop: 'Winkel',
    version: 'Versie',
    notice: {
      velofollies: 'Zien wij jullie op 20,21,22 januari ook op'
    }
  },

  Map: {
    tools: {
      search: 'Zoek voertuig naam of imei.',
      noData: 'Geen voertuigen gevonden..',
      noResults: 'Pas je zoekopdracht aan!',
      showFleet: 'Opnieuw centreren'
    },
    sidebar: {
      reload: 'Herladen',
      loadMore: 'Meer laden',
      trips: {
        title: 'Ritten',
        dayTotals: 'Totaal deze dag: '
      },
      error: {
        noTrips: 'Je hebt nog geen ritten op dit moment.',
        noMarkers: 'Er ging wat fout bij het ophalen van je rit.'
      },
      information: {
        title: 'Informatie',
        lastLocation: 'Laatste locatie',
        noLastLocation: 'Geen laatste locatie',
        lastActivity: 'Laatste activiteit',
        noLastActivity: 'Geen laatste activiteit',
        odoDistance: 'ODO Afstand',
        brand: 'Merk',
        noBrand: 'Geen merk ingevuld',
        model: 'Model',
        noModel: 'Geen model ingevuld',
        powerUnit: 'Power unit',
        noPowerUnit: 'Geen power unit ingevuld',
        vehicleType: 'Voertuig type',
        noVehicleType: 'Geen voertuig type ingevuld',
        imei: 'IMEI',
        vendor: 'Vendor',
        business: 'Relatie',
        noVendor: 'Geen gekoppelde vendor',
        notApplicable: 'n.v.t.'
      }
    }
  },

  InstallDevices: {
    title: 'Trackers installeren',
    infoGuideNotice: 'De pagina is recent aangepast, bekijk de toevoeging hier',
    notice: 'Locatie op kaart tijdelijk niet beschikbaar voor consumenten fietsen ivm nieuwe AVG feature',
    noticeBosch1: 'LET OP: Controleer bij ',
    noticeBosch2: ' motoren of de power poort is geactiveerd met de Bosch software.',
    noticeConsumerInfo: '*Het e-mailadres en telefoonnummer zijn voor administratie doeleinden (wij versturen geen activatie mail naar de consument)',
    form: {
      types: {
        eBike: 'e-bike',
        eCargoBike: 'bakfiets',
        speedPedelec: 'speed pedelec',
        eMoped: 'e-scooter',
        moped: 'scooter',
        automobile: 'automobiel',
        other: 'anders'
      },
      buttons: {
        install: 'Installeer',
        replace: 'Vervang',
        useQRScanner: 'QR scannen met camera',
        importPreset: 'Set importeren',
        savePreset: 'Set gelijk importeren bij volgende installatie',
        createNewPreset: 'Nieuwe set aanmaken',
        managePresets: 'Maak of wijzig set',
        editPreset: 'Bestaande set aanpassen',
        deletePreset: 'Verwijder set',
        createPreset: 'Maak set',
        nextStep: 'Volgende stap',
        import: 'Importeren',
        createTags: 'Labels maken',
        information: 'Informatie en gids',
        returnForm: "Retourformulier"
      },
      title: {
        create: 'Nieuw voertuig aanmaken',
        replace: 'Voertuig vervangen',
        managePreset: 'Set beheer'
      },
      panelHeaders: {
        target: 'Gebruik',
        device: 'Tracker',
        vehicleData: 'Voertuiggegevens',
        details: 'Details'
      },
      tabs: {
        create: 'Installeer tracker',
        replace: 'Vervang tracker'
      },
      subTitles: {
        selectPlan: 'Selecteer onderhoudsplan',
        noPlansAvailable: 'Geen onderhoudsplan gevonden',
        selectTags: 'Selecteer labels'
      },
      radioButtons: {
        forCustomer: 'Voor consument',
        forCustomerTooltip: 'Consument is facturabel',
        forOwnUse: 'Eigen gebruik',
        forOwnUseTooltip: 'U bent facturabel'
      },
      placeholders: {
        presetName: 'Set naam',
        name: 'Voertuig naam',
        frameNumber: 'Framenummer',
        licensePlate: 'Kenteken',
        odo: 'Kilometerstand',
        imei: 'Voer IMEI nummer in...',
        maintenancePlans: 'Onderhoudsplannen',
        other: 'Anders',
        brand: 'Merk',
        type: 'Voertuig type',
        powerunit: 'Power unit',
        engine: 'Motor',
        engineBrand: 'Motor merk',
        engineType: 'Motor type',
        model: 'Model',
        tagGroups: 'Instellingen (label groep)',
        firstNameCustomer: 'Voornaam consument',
        lastNameCustomer: 'Achternaam consument',
        customerEmail: 'Email consument',
        customerPhone: 'Telefoonnummer consument',
        color: 'Kleur',
        extraTag: 'Extra label toevoegen',
        preset: 'Selecteer set'
      },
      imei: {
        search: 'Zoek een IMEI nummer.',
        searching: 'Zoeken, geduld alstublieft',
        notFound: 'Geen device gevonden',
        needNumbers: 'Geef nog {0} nummer{1} op',
        tip: 'Tip: Typ de laatste 6 cijfers, dit is snel en secuur',
        huyserImei: 'Let op! Deze tracker is bestemd voor een Huyser fiets'
      },
      validation: {
        name: {
          required: 'Naam is verplicht',
          length: 'Naam bestaat uit minstens 4 karakters'
        },
        odo: {},
        device: {
          required: 'IMEI nummer is verplicht'
        },
        frameNumber: {
          required: 'Framenummer is verplicht',
          length: 'Framenummer bestaat uit minstens 4 karakters'
        },
        licensePlate: {
          required: 'Kentekenbewijs is verplicht',
          length: 'Kentekenbewijs bestaat uit minstens 4 karakters'
        },
        customerInfoRequired: 'Consumentgegevens zijn verplicht',
        customerEmail: {
          valid: 'Vul een correcte email in'
        }
      },
      messages: {
        fillAllFields: 'Vul alle velden in',
        errorFromServer: 'Error vanuit server',
        success: 'Entiteit aangemaakt',
        typeBrandAreRequired: 'Type en merk zijn verplicht.'
      },
      device: 'Tracker',
      groups: 'Label groepen',
      tags: 'Labels',
      actions: {
        create: 'Voertuig aanmaken',
        replace: 'Voertuig vervangen',
        save: 'Voertuig opslaan',
        cancel: 'Annuleren',
        search: 'Zoek op IMEI nummer.'
      }
    },

    listTitle: 'Laatste 20 aangemaakte voertuigen',
    noData: 'Geen voertuigen gevonden!',
    noEntitiesTitle: 'Geen voertuigen!',
    noEntitiesSubtitle: 'Maak nu je eerste voertuig!',

    tooltips: {
      mapLocation: 'Bekijk op kaart',
      status: 'Status',
      delete: 'Verwijder'
    }
  },

  ImeiStatus: {
    tab: 'Status',
    serviceStatus: 'Service status',
    serviceStatuses: {
      connecting: 'Verbinden',
      connected: 'Wachten op updates',
      live: 'Live'
    },
    consentDialog: {
      title: 'Heb je toestemming van de consument?',
      text: 'Deze actie vereist het inzien van de locatie en de recente trips van het voertuig. Indien nodig, versturen wij een email naar de klant om ze op de hoogte te brengen van het feit dat hun locatie wordt gedeeld.',
      confirm: 'Ja ik heb toestemming',
      cancel: 'Nee ga terug'
    },
    headers: {
      entityInfo: 'Voertuig informatie',
      liveUpdates: 'Live tracker updates'
    },
    liveUpdates: {
      connectionError: 'Kon niet verbinden met de service',
      lastUpdate: 'Laatste update',
      currentSpeed: 'Snelheid',
      heading: 'Richting',
      network: 'Netwerk',
      GPS: 'GPS',
      externalBattery: 'Spanning fietsaccu',
      connectedWaitingForUpdates: 'Aan het wachten op updates van de tracker...',
      noPastLocations: 'Let op! Deze tracker heeft geen historische locatie! Waarschijnlijk is deze niet goed aangesloten!',
      makeSureBikeOutside: 'Zorg dat het voertuig buiten is, aan staat en recent heeft bewogen.',
      noUpdateNotice: 'Als hij na 5 minuten nog geen update toont dan is de tracker waarschijnlijk verkeerd aangesloten of defect.'
    },
    map: {
      connectingToService: 'Verbinden met live updates service...',
    },
    tooltips: {
      requestLocationUpdate: 'Locatie update opvragen',
      mapLocation: 'Toon locatie op de kaart',
      openInDebugView: 'Tracker controleren in debug pagina',
      lastWaypointsStrongGps: 'Deze tracker heeft een sterk GPS signaal gehad in de laatste 10 waypoints',
      lastWaypointsMediumGps: 'Deze tracker heeft een matig GPS signaal gehad in de laatste 10 waypoints',
      lastWaypointsWeakGps: 'Deze tracker heeft geen GPS signaal gehad in de laatste 10 waypoints',
      recentlyOnline: 'Deze tracker was online in de laatste 24 uur',
      notRecentlyOnline: 'Deze tracker was offline voor de laatste 24 uur',
      externalBatteryConnected: 'De fietsaccu is verbonden met de tracker',
      externalBatteryDisconnected: 'Controleer de aansluiting van de tracker',
      strongGps: 'Sterk gps signaal',
      mediumGps: 'Gemiddeld gps signaal',
      weakGps: 'Zwak gps signaal',
      networkConnected: 'Netwerk verbonden',
      networkDisconnected: 'Meer dan 3 minuten geen update gehad'
    },
    noTripsToday: 'Geen ritten van vandaag gevonden.'
  },

  Reports: {
    title: 'Rapportages',
    periodic: {
      title: 'Periodiek overzicht',
      target: 'Doelgroep',
      request: 'Rapportage aanvragen per mail (CSV)',
      requestDone: 'Rapport succesvol ingediend. U ontvangt zo spoedig mogelijk een e-mail.',
      requestFail: 'Er is een fout opgetreden bij het opvragen van uw rapport. Probeer het opnieuw.',
      error: 'Deze groep bevat teveel voertuigen. Selecteer een andere.'
    },
    multiple: {
      all: 'Meerdere voertuigen',
      summary: 'Meerdere voertuigen (Samenvatting)'
    },
    individual: 'Individueel overzicht',
    period: 'Periode',
    date: 'Datums',
    toolbar: {
      selectEntity: 'Selecteer een voertuig',
      selectUser: 'Selecteer een gebruiker',
      selectDates: 'Selecteer datums'
    },

    tooltips: {
      //
    },

    table: {
      headers: {
        startTime: 'Starttijd',
        startAddress: 'Startadres',
        stopTime: 'Stoptijd',
        stopAddress: 'Stop adres',
        distance: 'Afstand',
        duration: 'Duur',
        averageSpeed: 'Gemiddelde snelheid',
        idle: 'Tijd op lokatie',
        id: 'ID',
        vendor: 'Vendor',
        odo: 'Odo',
        lastSeen: 'Laatst gezien',
        tags: 'Tags',
        name: 'Naam'
      },
      actions: {
        receiveThroughEmail: 'Rapportage per e-mail ontvangen'
      },
      noDataText: {
        all: 'Geef uw datumbereik op en selecteer een voertuig om door te gaan.',
        date: 'Geef uw datumbereik op om door te gaan.',
        user: 'Selecteer een gebruiker.',
        searched: 'Geen resultaten gevonden... te grote datumbereiken worden niet getoond. Klik in dat geval op de knop hierboven om via e-mail aan te vragen.',
        clickSearch: 'Klik op zoeken om door te gaan.'
      }
    }
  },

  // Analytics View
  Analytics: {
    title: 'Analytics',
    chart: {
      from: 'Van',
      till: 'Tot',
      total: 'Totaal aantal voertuigen',
      noDataTitle: 'Geen gegevens beschikbaar',
      noDataText: 'Er zijn geen gegevens voor de opgegeven parameters.'
    },
    toolbar: {
      addChart: 'Grafiek toevoegen',
      addChartTip: 'Genereer een grafiek met de + knop aan de rechterkant om hier een grafiek weer te geven.'
    },
    tooltips: {
      addChart: 'Add new chart'
    },
    dialog: {
      title: 'Nieuwe grafiek toevoegen',
      fields: {
        preset: 'Kies een voorinstelling',
        targetGroup: 'Doelgroep (optioneel)',
        dateRange: 'Selecteer datums'
      },
      actions: {
        create: 'Voeg grafiek toe',
        save: 'Grafiek opslaan',
        cancel: 'Annuleren'
      }
    },
    queries: {
      activityDay: 'Activiteit afhankelijk van het tijdstip van de dag (UTC-tijd)',
      activityWeek: 'Activiteit afhankelijk van de dag van de week',
      averageDistancePerTrip: 'Gemiddelde afstand per rit',
      averageDurationPerTrip: 'Gemiddelde duur per rit',
      averageSpeedPerTrip: 'Gemiddelde snelheid per rit',
      totalDistancePerTrip: 'Totale afstand per dag',
      totalDistancePerMonth: 'Totale afstand per maand',
      totalDurationPerDay: 'Totale duur per dag',
      totalDurationPerMonth: 'Totale duur per maand',
      newEntitiesPerDay: 'Nieuwe voertuigen per dag'
    }
  },

  Businesses: {
    tooltips: {
      edit: 'Bewerk {0}',
      delete: 'Verwijder {0}'
    },
    statistics: {
      availableDevices: 'Vrije trackers:',
      totalSubscriptions: 'Totale abonnementen:'
    },
    toolbar: {
      search: 'Relaties zoeken',
      noVendor: 'Selecteer een leverancier',
      options: 'Meer opties',
      editBusiness: 'Bewerk {0}',
      createBusiness: 'Relatie aanmaken',
      deleteBusiness: 'Verwijder {0}',
      createUser: 'Maak een gebruiker aan',
      linkToBusiness: 'Voertuigen koppelen aan relatie'
    },
    treeView: {
      noVendors: 'Geen leveranciers gevonden'
    },
    form: {
      name: 'Naam',
      address: 'Adres',
      postcode: 'Postcode',
      city: 'Plaats',
      country: 'Land',
      email: 'E-mail',
      phone: 'Telefoon',
      businessPropertiesTitle: 'Super admin specifieke business properties:',
      parentBusiness: 'Bovenliggende relatie',
      createRootBusiness: 'Maak een bovenliggende relatie aan',
      nameUpper: 'Naam en framenummer altijd in hoofdletters',
      hasCustomers: 'Heeft klanten (dealer)',
      canInstallDevices: 'Mag trackers installeren',
      recoveryContract: 'Opsporings contract'
    },
    dialog: {
      linkToBusiness: 'Voertuigen koppelen aan relatie',
      deleteBusiness: 'Relatie verwijderen',
      createUserForVendor: 'Gebruiker voor vendor aanmaken',
      createBusiness: 'Relatie aanmaken',
      editBusiness: 'Relatie bewerken',
      selectBusiness: 'Selecteer relatie',
      delete: {
        deleteUser: 'Gebruiker verwijderen',
        areYouSure: 'Weet u zeker dat u deze gebruiker wilt verwijderen?',
        userDeleted: 'Gebuiker succesvol verwijdererd.',
        error: 'Er ging iets mis. Probeer het nogmaals.'
      },
      update: {
        success: 'Gebruiker succesvol geupdate',
        error: 'Er ging iets mis. Probeer het nogmaals.'
      },

      fields: {
        firstName: 'Voornaam',
        lastName: 'Achternaam',
        address: 'Adres',
        postcode: 'Postcode',
        city: 'Plaats',
        phone: 'Telefoon',
        email: 'E-mail',
        role: 'Rol',
        vendor: 'Leverancier',
        password: 'Tijdelijk wachtwoord',
      }
    },
    devicesTab: {
      title: 'Trackers',
      search: 'Trackers zoeken',
      subtitle: 'Trackers van {0}',
      headers: {
        name: 'Naam',
        imei: 'IMEI',
        entityName: 'Voertuig naam',
        business: 'Relatie',
        lastSeen: 'Laatst gezien',
        createdAt: 'Gemaakt op',
        location: 'Lokatie'
      }
    },
    entitiesTab: {
      title: 'Voertuigen',
      search: 'Voertuigen zoeken',
      subtitle: 'Voertuigen van {0}',
      headers: {
        name: 'Naam',
        frameNumber: 'Framenummer',
        deviceImei: 'Tracker IMEI',
        business: 'Relatie',
        userName: 'Consumentennaam',
        lastSeen: 'Laatst gezien',
        subscription: 'Abonnement',
        createdAt: 'Gemaakt op',
        linkTo: 'Acties'
      }
    },
    usersTab: {
      title: 'Gebruikers',
      search: 'Gebruikers zoeken',
      subtitle: 'Gebruikers van {0}',
      headers: {
        name: 'Naam',
        firstName: 'Voornaam',
        lastName: 'Achternaam',
        email: 'E-mail',
        role: 'Rol',
        business: 'Relatie',
        createdAt: 'Gemaakt op',
        updatedAt: 'Bijgewerkt op',
        lastSeen: 'Laatst gezien',
        actions: 'Acties'
      }
    },

    dialogs: {
      actions: {
        create: 'Voeg {0} toe',
        save: '{0} opslaan',
        cancel: 'Annuleren'
      },
      linkUser: {
        title: 'Koppel voertuig aan gebruiker',
        fields: {
          select: 'Selecteer een gebruiker'
        }
      },
      linkVendor: {
        title: 'Koppel items aan een leverancier',
        fields: {
          select: 'Selecteer leverancier'
        }
      },
      createUser: {
        title: 'Maak een gebruiker voor leverancier',
        fields: {
          firstName: 'Voornaam',
          lastName: 'Achternaam',
          address: 'Adres',
          postcode: 'Postcode',
          city: 'Plaats',
          phone: 'Telefoon',
          email: 'E-mail',
          userRole: 'Gebruikers rol',
          role: 'Gebruikers rol',
          vendor: 'Leverancier',
          password: 'Tijdelijk wachtwoord',
          passwordHint: 'Dubbelklik op het veld om een nieuw wachtwoord te genereren.'
        }
      }
    }
  },

  // Tag Management View
  TagManagement: {
    types: {
      general: 'Algemeen',
      powerunit: 'Power unit',
      type: 'Voertuig type',
      group: 'Groep',
      model: 'Model',
      brand: 'Merk',
      selected: 'Geselecteerd'
    },
    tagGroups: {
      model: {
        titleCase: {
          single: 'Label groep',
          plural: 'Labelgroepen'
        },
        lowerCase: {
          single: 'label groep',
          plural: 'labelgroepen'
        }
      },
      tooltips: {
        edit: 'Bewerk {0}',
        delete: 'Verwijder {0}'
      },
      table: {
        buttons: {
          //
        },
        headers: {
          name: 'Groepsnaam',
          tags: 'Labels in groep',
          actions: 'Acties'
        }
      },
      dialog: {
        title: {
          create: 'Nieuwe labelgroep',
          edit: 'Labelgroep bewerken'
        },
        fields: {
          name: 'Groepsnaam',
          tags: 'Labels'
        },
        actions: {
          create: 'Maak een labelgroep',
          save: 'Labelgroep opslaan',
          cancel: 'Annuleren'
        }
      }
    },
    tags: {
      model: {
        titleCase: {
          single: 'Label',
          plural: 'Labels'
        },
        lowerCase: {
          single: 'label',
          plural: 'labels'
        }
      },
      tooltips: {
        edit: 'Bewerk {0}',
        delete: 'Verwijder {0}'
      },
      toolbar: {
        search: 'Zoek'
      },
      table: {
        buttons: {
          //
        },
        headers: {
          name: 'Label naam',
          type: 'Type',
          group: 'Groep',
          actions: 'Acties'
        }
      },
      dialog: {
        title: {
          create: 'Nieuwe labelgroep',
          edit: 'Bewerk labelgroep'
        },
        fields: {
          name: 'Naam',
          type: 'Type',
          groups: 'Groepen'
        },
        actions: {
          create: 'Label maken',
          save: 'Label opslaan',
          cancel: 'Annuleren'
        }
      }
    }
  },

  // User Management View
  UserManagement: {
    model: {
      titleCase: {
        single: 'Gebruiker',
        plural: 'Gebruikers'
      },
      lowerCase: {
        single: 'gebruiker',
        plural: 'gebruikers'
      }
    },
    tooltips: {
      edit: 'Bewerk {0}',
      delete: 'Verwijder {0}',
      tokens: 'Sleutels',
      showEntities: 'Voertuigen tonen',
      goToSubscriptions: 'Naar {0}\'s abonnement'
    },
    toolbar: {
      search: 'Zoeken'
    },
    table: {
      buttons: {
        //
      },
      headers: {
        firstName: 'Voornaam',
        lastName: 'Achternaam',
        address: 'Adres',
        postcode: 'Postcode',
        city: 'Plaats',
        phone: 'Telefoon',
        telephone: 'Telefoon',
        email: 'E-mail',
        business: 'Relatie',
        lastSeen: 'Laatst gezien',
        role: 'Rol',
        actions: 'Actie'
      }
    },
    dialog: {
      title: {
        create: 'Nieuwe gebruiker',
        edit: 'Bewerk gebruiker',
        editAccount: 'Accountgegevens aanpassen',
      },
      fields: {
        firstName: 'Voornaam',
        lastName: 'Achternaam',
        address: 'Adres',
        postcode: 'Postcode',
        city: 'Plaats',
        phone: 'Telefoon',
        telephone: 'Telefoon',
        email: 'E-mail',
        userRole: 'Rol',
        business: 'Relatie',
        password: 'Tijdelijk wachtwoord',
        passwordHint: 'Dubbelklik op het veld om een nieuw wachtwoord te genereren.',
        changePassword: 'Wachtwoord veranderen',
        currentPassword: 'Huidig wachtwoord',
        newPassword: 'Nieuw wachtwoord',
        newPasswordConfirmation: 'Herhaal nieuw wachtwoord'
      },
      actions: {
        create: 'Gebruiker maken',
        save: 'Gebruiker opslaan',
        cancel: 'Annuleren',
        hardDelete: '{0} PERMANENT verwijderen',
        restore: '{0} herstellen'
      }
    }
  },

  Tables: {
    customize: 'Tabel aanpassen'
  },

  EntityManagement: {
    model: {
      titleCase: {
        single: 'Voertuig',
        plural: 'Voertuigen'
      },
      lowerCase: {
        single: 'voertuig',
        plural: 'voertuigen'
      }
    },
    snackbar: {
      requiredFields: 'Naam, Merk en Kleur zijn verplicht'
    },
    stepper: {
      add: 'Tags aan voertuigen koppelen',
      addTags: 'Tags toevoegen',
      overview: 'Overzicht',
      continue: 'Doorgaan',
      save: 'Melden',
      back: 'Terug',
      cancel: 'Annuleren',
      confirm: 'U staat op het punt om tags toe te voegen aan {0} {1}. Weet u het zeker?'
    },
    missing: {
      confirm: 'U staat op het punt om {0} {1} als vermist op te geven. Weet u het zeker?',
      report: 'Vermissing opgeven',
      modalTitle: 'Weet je het zeker?',
      modalText: 'Weet je het zeker dat je dit voertuig wilt opgeven als vermist aan de opsporings service?',
      uninsuredEntitiesWarning: 'De volgende voertuigen hebben geen verzekering en kunnen niet als vermist worden opgegeven.',
      continue: 'Wilt u doorgaan?',
      tryAgain: 'Selecteer een ander voertuig of registreer een verzekering.',
      reportedMissing: 'Als vermist opgegeven!'
    },
    noOdo: 'nvt',
    csvModal: {
      title: 'Tabel data per email ontvangen?',
      text: 'Je krijgt de huidige tabel resultaten binnen enkele minuten naar je gebruikers email toegestuurd.'
    },
    tooltips: {
      isCustomer: 'Consumenten voertuig',
      ownEntity: 'Eigen voertuig',
      csv: 'CSV tabeldata opvragen',
      create: 'Nieuw voertuig maken',
      tags: 'Voeg tags toe',
      missing: 'Voertuig opgeven als vermist',
      missingDisabled: 'Opsporings service uitgeschakeld, bent u geïnteresseerd in deze service? Neem contact op met support',
      deleteDisabled: 'Kan niet worden verwijderd omdat er consument aan gekoppeld is',
      showAsQr: 'IMEI als QR-code laten zien'
    },
    toolbar: {
      title: {
        filtered: '{0} van de {1} entities',
      },
      search: 'Zoeken'
    },
    table: {
      buttons: {
        edit: 'Bewerk {0}',
        view: 'Bekijk {0}',
        delete: 'Verwijder {0}'
      },
      headers: {
        name: 'Voertuig naam',
        frameNumber: 'Framenummer',
        deviceImei: 'Tracker IMEI',
        odo: 'ODO-afstand',
        vendor: 'Leverancier',
        subscription: 'Abonnement',
        targetGroup: 'Doelgroep',
        lastSeen: 'Laatst gezien',
        tags: 'Label',
        createdAt: 'Gemaakt op',
        createdBy: 'Gemaakt door',
        actions: 'Acties'
      }
    },
    dialog: {
      unregisteredEntityHelper: "Om een niet-geregistreerde voertuig te wijzigen, verwijder deze dan en maak een nieuwe aan met de functie 'Trackers Installeren'.",
      title: {
        create: 'Nieuw voertuig',
        edit: 'Bewerk voertuig',
        details: 'Voertuig informatie',
        tags: 'Selecteer tags'
      },
      fields: {
        name: 'Naam',
        imei: 'IMEI',
        frameNumber: 'Framenummer',
        deviceImei: 'Tracker IMEI',
        vendor: 'Leverancier',
        targetGroup: 'Doelgroep',
        odo: 'ODO-afstand',
        metrics: 'Eenheid'
      },
      actions: {
        create: 'Bewerk voertuig',
        save: 'Voertuig opslaan',
        cancel: 'Annuleren'
      }
    }
  },

  MaintenancePlans: {
    title: 'Onderhoudsplannen',
    toasts: {
      planned: 'Melding gepland',
      completed: 'Melding gemarkeerd als voltooid',
      open: 'Melding gemarkeerd als open',
      archived: 'Melding gearchiveerd',
      userAssigned: 'Gebruiker toegewezen',
      userUnassigned: 'Gebruiker niet toegewezen'
    },
    tooltips: {
      createPlan: 'Maak een onderhoudsplan',
      editPlan: 'Bewerk {0}',
      deletePlan: 'Verwijder {0}',
      openPlan: 'Toon {0} details',
      activatePlan: 'Activeer {0}',
      deactivatePlan: 'Deactiveer {0}',
      assignUser: 'Wijs gebruiker toe',
      addDate: 'Datum toevoegen',
      changeDate: 'Verander de datum',
      completeNotification: 'Voltooi melding',
      archiveNotification: 'Archiveer melding',
      showDetails: 'Toon details',
      hideDetails: 'Verberg details'
    },
    general: {
      allAssignedEntites: 'Alle voertuigen zijn gekoppeld aan dit plan',
      createNewTrigger: 'Maak nieuwe trigger aan',
      selectTrigger: 'Selecteer bestaande trigger',
      mustHaveTitle: 'Het plan dient een titel te bevatten',
      mustHaveDescription: 'Het plan dient een omschrijving te bevatten',
      maxLength: 'De maximale lengte voor een beschrijving is 250 karakters.',
      name: 'Naam',
      frameNumber: 'Frame nummer',
      tags: 'Tags',
      vendor: 'Leverancier',
      value: 'Waarde',
      metric: 'Metriek',
      description: 'Omschrijving',
      actions: 'Acties',
      allEntities: 'Alle voertuigen',
      searchEntities: 'Zoeken',
      searchTriggers: 'Zoek trigger',
      notifications: 'Notificaties',
      notDeleted: 'Niet verwijderd',
      pfew: 'Niet verwijderd',
      notConfirmed: 'Niet bevestigd',
      confirmOrDismiss: 'Bevestig om te verwijderen',
      planDeleted: 'Plan verwijderd',
      wasDeleted: 'Plan succesvol verwijderd',
      deleteFailed: 'Verwijderen mislukt',
      planNotDeleted: 'Plan niet verwijderd',
      getPlanFailed: 'Er ging iets mis',
      wrongGettingPlan: 'Er ging iets mis bij het ophalen van het plan. Contacteer Tracefy.',
      failed: 'Mislukt',
      failedGettingTriggers: 'Er ging iets mis met het ophalen van de triggers. Contacteer Tracefy.',
      failedGettingPlanEntities: 'Er ging iets mis met het ophalen van de voertuigen. Contacteer Tracefy.',
      failedRemovePlan: 'Verwijderen van voertuig mislukt',
      wrongActivatingPlan: 'Er ging iets mis bij het activeren van dit plan.',
      deletePlan: 'Plan verwijderen',
      areYouSure: 'Weet u het zeker?'
    },
    notification: {
      noOdo: 'Voertuig odo-afstand niet gevonden',
      noTrigger: 'Geen trigger toegewezen',
      noTriggerValue: 'Geen triggerwaarde',
      noUser: 'Geen gebruiker toegewezen',
      noEntity: 'Geen entiteit toegewezen'
    },
    toolbar: {
      searchText: 'Zoeken',
      filterText: 'Filter',
      sortByText: 'Sorteren op',
      plans: {
        sortOptions: {
          name: 'Naam',
          createdAt: 'Gemaakt op'
        },
        filterOptions: {
          activated: 'Geactiveerd',
          deactivated: 'Gedeactiveerd'
        }
      },
      notifications: {
        sortOptions: {
          entityName: 'Voertuig naam',
          userName: 'Toegewezen gebruikersnaam',
          tiggerName: 'Triggernaam',
          createdAt: 'Gemaakt op',
          plannedAt: 'Ingepland op'
        },
        filterOptions: {
          open: 'Open',
          done: 'Voltooid',
          archived: 'Gearchiveerd'
        }
      }
    },
    planTabs: {
      info: {
        title: 'Informatie'
      },
      triggers: {
        title: 'Triggers',
        headers: {
          name: 'Naam',
          value: 'Waarde',
          metric: 'Eenheid',
          actions: 'Acties'
        }
      },
      entities: {
        title: 'Voertuigen',
        headers: {
          name: 'Naam',
          tags: 'Labels',
          vendor: 'Leveranciers',
          actions: 'Acties'
        }
      }
    },
    save: 'Opslaan',
    close: 'Sluiten',
    switchLabel: 'Actief',
    planDialog: {
      validationRules: {
        required: 'Het plan moet een {0} hebben',
        maxLength: 'De maximale lengte voor de {0} is {1} tekens.'
      },
      title: 'Onderhoudsplan bewerken',
      save: 'Opslaan',
      close: 'Sluiten',
      createTrigger: 'Maak een nieuwe trigger',
      selectTrigger: 'Selecteer een bestaande trigger',
      searchTextTrigger: 'Zoek triggers',
      searchTextEntity: 'Zoek voertuigen',
      create: 'Creëer onderhoudsplan',
      edit: 'Bewerk onderhoudsplan',
      description: 'Omschrijving',
      active: 'Actief',

      stepOne: {
        title: 'Plan details',
        subtitle: 'Bewerk de titel en beschrijving',
        titleText: 'Titel',
        descriptionTitle: 'Beschrijving'
      },
      stepTwo: {
        title: 'Voertuigen',
        subtitle: 'Voertuigen aan dit plan toevoegen of verwijderen',
        allEntities: 'Alle voertuigen',
        searchText: 'Zoek voertuigen',
        headers: {
          name: 'Naam',
          frameNumber: 'Framenummer',
          tags: 'Labels',
          vendor: 'Leveranciers'
        }
      },
      stepThree: {
        title: 'Triggers',
        subtitle: 'Voeg triggers toe of verwijder deze voor dit plan',
        searchText: 'Zoek triggers',
        headers: {
          name: 'Naam',
          value: 'Waarde',
          metric: 'Eenheid',
          description: 'Omschrijving',
          actions: 'Acties'
        }
      }
    },
    noPlans: 'Nog geen onderhoudsplannen!',
    noPlanSearchResult: 'Geen onderhoudsplannen voor criteria!',
    noNotifications: 'Nog geen meldingen!',
    noNotificationSearchResult: 'Geen meldingen voor criteria!'
  },

  DeviceManagement: {
    model: {
      titleCase: {
        single: 'Tracker',
        plural: 'Trackers'
      },
      lowerCase: {
        single: 'tracker',
        plural: 'trackers'
      }
    },
    tooltips: {
      edit: 'Bewerk {0}',
      delete: 'Verwijder {0}'
    },
    toolbar: {
      title: {
        filtered: '{0} van de {1} trackers',
        total: 'Totaal'
      },
      search: 'Zoeken',
      selected: 'Geselecteerd: {0} trackers'
    },
    table: {
      buttons: {
        //
      },
      headers: {
        index: 'Index',
        title: 'Tracker',
        description: 'Omschrijving',
        imei: 'IMEI',
        iccid: 'ICCID',
        model: 'Model',
        firmwareVersion: 'Firmware versie',
        settingsCrc: 'Settings CRC',
        entityName: 'Voertuig Naam',
        subVendorName: 'Leverancier',
        lastSeen: 'Laatst gezien',
        createdAt: 'Gemaakt op',
        actions: 'Acties'
      }
    },
    dialog: {
      title: {
        create: 'Nieuwe tracker',
        edit: 'Bewerk tracker',
        linkDevicesDialog: 'Koppel trackers aan enterprise',
        scanDevicesDialog: 'Scan trackers'
      },
      fields: {
        title: 'Titel',
        description: 'Omschrijving',
        imei: 'IMEI',
        model: 'Model',
        firmwareVersion: 'Firmware versie',
        settingsCrc: 'Settings CRC',
        subVendorName: 'Enterprise',
        lastSeen: 'Laatst gezien',
        createdAt: 'Gemaakt op'
      },
      actions: {
        create: 'Maak tracker',
        save: 'Opslaan',
        cancel: 'Annuleren',
        exportAndSave: 'Exporteer & Opslaan'
      }
    },
    input: {
      placeholder: 'Selecteer enterprise'
    },
    sweetAlert: {
      title: '{0} trackers zijn niet gekoppeld!'
    }
  },

  // Token Management View
  TokenManagement: {
    title: 'API Sleutelbeheer',
    model: {
      titleCase: {
        single: 'Gebruiker',
        plural: 'Gebruikers'
      },
      lowerCase: {
        single: 'gebruiker',
        plural: 'gebruikers'
      }
    },
    tooltips: {
      edit: 'Bewerk {0}',
      delete: 'Verwijder {0}',
      tokens: 'Sleutels'
    },
    toolbar: {
      search: 'Zoeken'
    },
    table: {
      buttons: {
        //
      },
      headers: {
        firstName: 'Voornaam',
        lastName: 'Achternaam',
        address: 'Adres',
        postcode: 'Postcode',
        city: 'Plaats',
        phone: 'Telefoon',
        telephone: 'Telefoon',
        email: 'E-mail',
        vendor: 'Naam leverancier',
        role: 'Rol',
        actions: 'Acties'
      }
    },
    dialog: {
      title: {
        // Title is selected user.first_name + user.last_name
      },
      fields: {
        name: 'Sleutel naam'
      },
      tokenList: {
        created: 'Aangemaakt op: ',
        revoked: 'Ingetrokken op: '
      },
      actions: {
        create: 'Genereer sleutel',
        cancel: 'Annuleren'
      }
    }
  },

  // Subscription Management View
  SubscriptionManagement: {
    model: {
      titleCase: {
        single: 'Abonnement',
        plural: 'Abonnementen'
      },
      lowerCase: {
        single: 'abonnement',
        plural: 'abonnementen'
      }
    },
    tooltips: {
      create: 'Abonnement toevoegen',
      assign: 'Abonnement toewijzen',
      edit: 'Abonnement bewerken'
    },
    toolbar: {
      total: 'Totaal',
      search: 'Zoeken'
    },
    tree: {
      subscriptionEmpty: 'Kies een abonnement'
    },
    table: {
      fields: {
        title: 'Titel',
        description: 'Beschrijving',
        currency: 'Valuta',
        defaultPrice: 'Standaard prijs',
        discountPrice: 'Prijs na korting',
        period: 'Interval',
        periods: {
          year: 'Jaarlijks',
          month: 'Maandelijks',
          quarter: 'Elk kwartaal'
        },
        actions: 'Acties'
      }
    },
    tabs: {
      enterprises: {
        title: 'Enterprises',
        fields: {
          name: 'Naam',
          actions: 'Acties'
        }
      },
      vendors: {
        title: 'Vendors',
        fields: {
          name: 'Naam',
          actions: 'Acties'
        }
      },
      companies: {
        title: 'Companies',
        fields: {
          name: 'Naam',
          actions: 'Acties'
        }
      },
      departments: {
        title: 'Departments',
        fields: {
          name: 'Naam',
          actions: 'Acties'
        }
      }
    },
    dialog: {
      title: {
        create: 'Nieuw abonnement',
        edit: 'Abonnement bewerken',
        vendor: 'Leveranciersabonnement'
      },
      fields: {
        title: 'Titel',
        description: 'Beschrijving',
        defaultAmount: 'Standaard prijs',
        discountAmount: 'Prijs na korting',
        currency: 'Valuta',
        period: 'Periode',
        vendor: 'Leverancier',
        noVendor: 'Kies een leverancier'
      },
      actions: {
        create: 'Maak een abonnement aan',
        save: 'Abonnement opslaan',
        update: 'Leveranciersabonnementen bijwerken',
        cancel: 'Annuleren'
      }
    }
  },

  Information: {
    intro: {
      text: '',
      link: 'Op zoek naar onze api documentatie?'
    },

    tabs: {
      installation: 'Installatie gids',
      portal: 'Portal gids',
      marketing: 'Marketing',
      app: 'App gids'
    },
    videos: 'Videos',
    documents: 'Documenten (pdf)',
    images: 'Afbeeldingen'
  },

  Subscriptions: {
    table: {
      buttons: {
        save: 'Opslaan',
        cancel: 'Annuleren',
        close: 'Sluiten'
      },
      headers: {
        actions: 'Acties',
        orderId: 'Bestelling ID',
        status: 'Status',
        user: 'Gebruiker',
        brand: 'Merk',
        noUser: 'Gebruiker niet gevonden',
        entity: 'Voertuig',
        noEntity: 'Voertuig niet gevonden',
        subscription: 'Abonnement',
        noSubscription: 'Abonnement niet gevonden',
        startedAt: 'Begonnen op',
        ends: 'Eindigt op',
        noVendor: 'Geen vendor',
        paidAt: 'Betaald op',
        insurance: 'Verzekering',
        insuranceStart: 'Verzekerd op',
        insuranceEnds: 'Eindigt',
        price: 'Prijs',
        vendor: 'Vendor',
        date: 'Einddatum',
        frameNumber: 'Frame nummer',
        payment: 'Betaal methode'
      },
      paymentMethods: {
        mollie: 'Mollie',
        unknown: 'Onbekend'
      },
      edit: 'Aanpassen'
    },
    dialog: {
      title: 'Overzicht',
      headers: {
        insurance: 'Verzekering',
        subscription: 'Abonnement',
        orderID: 'Bestelling ID',
        user: 'Gebruiker',
        paidAt: 'Betaald op',
        entity: 'Voertuig',
        insuranceStartDate: 'Start datum',
        insuranceEndDate: 'Eind datum',
        frameNumber: 'Frame nummer',
        brand: 'Merk',
        vendor: 'Vendor',
        external: 'Betaal methode',
        startedAt: 'Started at',
        endedAt: 'Ended at'
      }
    },

    confirmation: {
      text: {
        confirm: 'U staat op het punt uw verzekering aan te passen. Wilt u doorgaan?'
      }
    }
  },

  Notifications: {
    createNotification: 'Nieuwe notificatie',
    editNotification: 'Notificatie aanpassen',
    lastSentNotifications: 'Laatst verstuurde notificaties',
    confirmDeleteMessage: 'Weet jij zeker dat je deze geplande notificatie wilt verwijderen?',
    scheduleNotification: 'Notificatie inplannen',
    updateNotification: 'Notificatie bijwerken',
    plannedNotifications: 'Geplande notificaties',
    deleteNotification: 'Verwijder deze geplande notificatie',
    validationFailedMessage: 'Datum, tijd, titel en bericht zijn verplichte velden!',
    allUsers: 'Alle consumenten',
    recipients: 'Ontvangers',
    selectDate: 'Datum',
    selectTime: 'Tijd',
    title: 'Titel',
    body: 'Typ hier je bericht'
  },

  Shop: {
    addedToCart: 'Aan winkelwagen toegevoegd!'
  },

  AppBar: {
    changeLanguage: 'Taal aanpassen',
    toggleNightmode: 'Nachtmodus aan/uitzetten',
    toggleChristmas: 'Kerstmis aan/uitzetten',
    logout: 'Uitloggen'
  },

  Support: {
    emailUs: 'Email ons',
    callOrApp: 'Bel of App ons',
    weekdays: 'ma-vr'
  },

  Snackbar: {
    success: 'Geslaagd!',
    generalError: 'Actie mislukt!'
  }
}
